import {
  START_NOTIFICATION_SERVICE,
  NOTIFICATION_SERVICE_STARTED,
  NOTIFICATION_SERVICE_ERROR,
  NOTIFICATION_RECEIVED as ON_NOTIFICATION_RECEIVED,
  TOKEN_UPDATED,
} from 'electron-push-receiver/src/constants';

export const initNotificationsService = ({ onTokenReceived, onTokenUpdated, onNotificationReceived }) => {
  const ipcRenderer = window.ipcRenderer;
  if (!ipcRenderer) {
    return;
  }

  // Listen for service successfully started
  ipcRenderer.on(NOTIFICATION_SERVICE_STARTED, (_, token) => onTokenReceived(token));
  // Handle notification errors
  ipcRenderer.on(NOTIFICATION_SERVICE_ERROR, (_, error) => console.error(error));
  // Send FCM token to backend
  ipcRenderer.on(TOKEN_UPDATED, (_, token) => onTokenUpdated(token));
  // Display notification
  ipcRenderer.on(ON_NOTIFICATION_RECEIVED, (_, notification) => onNotificationReceived(notification));
  // Start service
  ipcRenderer.send(START_NOTIFICATION_SERVICE, '325034112439');
}
